import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";
import DownloadForOfflineOutlinedIcon from "@mui/icons-material/DownloadForOfflineOutlined";
import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "./style.scss";

export const DiscourseCard = ({
  name,
  description,
  file,
  fileName,
  extension = "wav",
  size = "md",
  fileSize,
  bucket,
  transcribe,
  transcribeUrl,
  transcriptionSize,
  retreat,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);
  // const downloadBook = () => {
  //       const element = document.createElement("a");
  //       element.href = `${bucket}/${fileName}`;
  //       element.download = `${fileName}`;
  //       element.click();
  //   }

  const downloadBook = async (fileURI) => {
    const response = await fetch(`${bucket}/${fileURI}`);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileURI;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
  // Handles clicking the initial mini button
  const handleMiniButtonClick = () => {
    setIsOpen(true);
    // Give the modal a brief moment to mount before playing
    setTimeout(() => {
      if (audioRef.current && audioRef.current.audio.current) {
        audioRef.current.audio.current.play();
      }
    }, 50);
  };

  return (
    <div className={"discourseCardContainer"}>
      <h1 className="card-title">{name}</h1>
      {!isPlaying && (
        <button className="mini-play-btn" onClick={handleMiniButtonClick}>
          <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M8 5v14l11-7z" />
          </svg>
        </button>
      )}

      {/* 2. THE POPUP MODAL (Large UI) */}
      {isOpen &&
        createPortal(
          <div className="audio-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
              className="audio-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="close-modal-btn"
                onClick={() => setIsOpen(false)}
              >
                &times;
              </button>

              <h3 className="modal-title">{name}</h3>
              <AudioPlayer
                volume={0.8}
                preload="none"
                // showSkipControls
                progressUpdateInterval={100}
                layout="horizontal-reverse"
                // showJumpControls={false}
                // showSkipControls={false}
                customVolumeControls={[]}
                customAdditionalControls={[]}
                crossOrigin="anonymous"
                src={`${bucket}/${retreat}/${encodeURIComponent(fileName)}`}
                onError={(e) => {
                  // FIX 2: Expose the hidden media error code hiding behind { isTrusted: true }
                  console.error(
                    "Audio Engine Error Code:",
                    e.target.error ? e.target.error.code : "Unknown",
                  );
                }}
                ref={audioRef}
                autoPlay={true}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
              />
            </div>
          </div>,
          document.body,
        )}
      <div className="downloadContainer">
        {transcribe && (
          <span
            className="download-text"
            onClick={() => downloadBook(`${retreat}/${transcribeUrl}`)}
          >
            <SimCardDownloadOutlinedIcon style={{ marginRight: 10 }} /> (
            {transcriptionSize})
          </span>
        )}
        <span
          className="download-text"
          onClick={() => downloadBook(`${retreat}/${fileName}`)}
        >
          <DownloadForOfflineOutlinedIcon style={{ marginRight: 10 }} /> (
          {fileSize})
        </span>
      </div>
    </div>
  );
};
